import { readonly, ref, useContext } from "@nuxtjs/composition-api";
import { Logger } from "@wemade-vsf/core";
import { useCart } from "@wemade-vsf/customer";
function useShipping() {
  const loading = ref(false);
  const error = ref({ load: null, save: null });
  const { cart, load: loadCart } = useCart();
  const { app } = useContext();
  const load = async (params = {}) => {
    var _a;
    Logger.debug("useShipping.load");
    let shippingInfo = null;
    try {
      loading.value = true;
      if (((_a = cart == null ? void 0 : cart.value) == null ? void 0 : _a.shipping_addresses.length) === 0) {
        await loadCart(params);
      }
      [shippingInfo] = cart.value.shipping_addresses;
      error.value.load = null;
    } catch (err) {
      error.value.load = err;
      Logger.error("useShipping/load", err);
    } finally {
      loading.value = false;
    }
    return shippingInfo;
  };
  const save = async ({ shippingDetails }) => {
    Logger.debug("useShipping.save");
    if (!cart.value) {
      Logger.warn("useShipping/save", "Cart is undefined, try to load...");
      await loadCart();
    }
    if (!cart.value) {
      Logger.error("useShipping/save", "Cart is still undefined after trying to load");
      return;
    }
    let shippingInfo = null;
    try {
      loading.value = true;
      const { id } = cart.value;
      const {
        apartment,
        neighborhood,
        extra,
        customerAddressId,
        ...address
      } = shippingDetails;
      const shippingData = customerAddressId ? { customer_address_id: customerAddressId } : {
        address: {
          ...address,
          street: [
            ...Array.isArray(address.street) ? address.street : [address.street],
            apartment,
            neighborhood,
            extra
          ].filter(Boolean)
        }
      };
      const shippingAddressInput = {
        cart_id: id,
        shipping_addresses: [
          {
            ...shippingData
          }
        ]
      };
      const { data } = await app.$vsf.$magento.api.setShippingAddressesOnCart(shippingAddressInput);
      Logger.debug("[Result]:", { data });
      [shippingInfo] = data.setShippingAddressesOnCart.cart.shipping_addresses;
      error.value.save = null;
    } catch (err) {
      error.value.save = err;
      Logger.error("useShipping/save", err);
    } finally {
      loading.value = false;
    }
    return shippingInfo;
  };
  return {
    load,
    save,
    error: readonly(error),
    loading: readonly(loading)
  };
}
export * from "./useShipping";
var useShipping_default = useShipping;
export {
  useShipping_default as default,
  useShipping
};
